import React, { Component } from 'react'
import './LocationSelector.css'

import Feedback from '../Feedback';
import Location from '../Location'
import { LocationSearchEmpty } from '../Search';
import getIspData from '../../utils/get_isp_data';
import localize from '../localize';

export class LocationSelector extends Component {
  constructor(props) {
    super(props)

    this.expandOrContract = this.expandOrContract.bind(this)
    this.state = {
      expanded: false
    }
  }

  expandOrContract() {
    this.setState({ expanded: !this.state.expanded })
  }

  render() {
    const { i18n, player, switchPlayerLocation, shard } = this.props
    const { expanded } = this.state
    const that = this
    const chooseLocation = (l) => {
      switchPlayerLocation(l)
      that.setState({ expanded: false })
    }

    var topLine = [
      <td key="current-label" className="current-location-label">
        { !expanded && <Feedback><img className="icon-container" src={require('./flag-icon.png')} alt={i18n.t('feedback.provide_feedback')} /></Feedback> }
        <Location location={player.location.location} hideCountry={true} /> | {player.isp.name}
      </td>
    ]

    topLine.push(<td key="dropdown" className="label right-align">{i18n.t('pages.scores.changeLocation.change_location')}<q-icon className="caret" name={`caret-${expanded? 'up' : 'down'}`} size="sm" /></td>)

    const listing = (player.player_stats || [])
      .filter((l) => !l.unsupported_country)
      .sort((a, b) => getIspData(b.stats).stats_overall.player_games - getIspData(a.stats).stats_overall.player_games)
      .map((l, i) => (
      <div className="location-option" key={i} onClick={() => chooseLocation(l)}><Location location={l.location.location} hideCountry={true} /> | {l.isp.name} ({getIspData(l.stats).stats_overall.player_games} {i18n.t('pages.scores.changeLocation.games')})</div>
    ))

    if (listing.length > 0) {
      listing.unshift(<div key="label" className="label">{i18n.t('pages.scores.changeLocation.locations')}</div>)
    }

    const currentLocation = player.isLoggedIn? player.ip_location : player.location

    listing.push(
      <div key="bottom" className="location-selector-bottom">
        <q-grid fluid>
          <q-col md-size={player.isLoggedIn? "4" : "6"} className="feedback-line">
            <Feedback>
              <div className="location-selector-button-content not-flex">
                <div className="location-selector-button-inner not-flex">
                  <img className="icon-container" src={require('./flag-icon.png')} alt={i18n.t('feedback.provide_feedback')} /><span>{i18n.t('feedback.provide_feedback')}</span>
                </div>
              </div>
            </Feedback>
          </q-col>
          <q-col md-size={player.isLoggedIn? "4" : "6"} className="search-line">
            <LocationSearchEmpty currentLocation={player.location.location} shard={shard}>
              <div className="location-selector-button-content not-flex">
                <div className="location-selector-button-inner not-flex">
                  <img className="icon-container" src={require('./search-icon.png')} alt={i18n.t('search.header')} /><span>{i18n.t('search.header')}</span>
                </div>
              </div>
            </LocationSearchEmpty>
          </q-col>
          {
            player.isLoggedIn &&
            <q-col md-size={player.isLoggedIn? "4" : "6"} className="use-current-line">
              <div onClick={() => chooseLocation(currentLocation)} className="location-selector-button-content not-flex">
                <div className="location-selector-button-inner not-flex">
                  <img className="icon-container" src={require('./locate-icon.png')} alt={i18n.t('pages.scores.changeLocation.use_current')} /><span>{i18n.t('pages.scores.changeLocation.use_current')}</span>
                </div>
              </div>
            </q-col>
          }
        </q-grid>
      </div>
    )

    return (
      <div className="location-selector-container">
        <div className="centered-content">
          <div className="location-selector">
            <table>
              <tbody>
                <tr className="location-option current-location" onClick={this.expandOrContract}>
                  { topLine }
                </tr>
              </tbody>
            </table>
            <div className="location-selector-dropdown">
              { expanded? listing : <div/> }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default localize()(LocationSelector)



// WEBPACK FOOTER //
// ./src/components/LocationSelector/index.js